const styles = theme => ({
  entityContainer: {
    padding: '24px',
    [theme.breakpoints.down('xs')]: {
      padding: '0px 0px 24px 0px',
    },
  },
  entity: {
    gridTemplateColumns: '2fr 3fr',
    margin: '24px 0px',
    paddingBottom: '24px',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '2fr',
    },
  },
  profileCls: {
    width: '62px',
    height: '62px',
  },
  subItemContainer: {
    gridColumn: 'span 2',
    marginTop: '1rem',
    paddingTop: '1rem',
    borderTop: '1px solid #EBEEF3',
  },
  subItemTitle: {
    fontWeight: '600',
    fontSize: '1rem',
    marginBottom: '1rem',
  },
  flexCls: {
    display: 'flex',
    gap: '15px',
    [theme.breakpoints.down('xs')]: {
      padding: '16px',
    },
  },
  labelsWrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: '20px',
    rowGap: '16px',
    [theme.breakpoints.down('xs')]: {
      columnGap: 'unset',
      display: 'flex',
      flexDirection: 'column',
      rowGap: '0px',
    },
    [theme.breakpoints.down('md')]: {
      columnGap: '45px',
    },
  },
  labels: {
    padding: '0px 16px',
    [theme.breakpoints.down('xs')]: {
      padding: '16px',
    },
  },
  divider: {
    backgroundColor: '#EBEEF3',
  },
  ArFont: {
    fontFamily: '"madani", sans-serif',
  },
  labelKey: {
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '21px',
    color: '#484456',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
  },
  nameCls: {
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '150%',
    marginTop: '4px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
      fontWeight: '500',
    },
  },
  labelValue: {
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '150%',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
      fontWeight: '500',
    },
  },
  gridDisplay: {
    display: 'grid',
    borderBottom: '4px solid #EBEEF3',
  },
  noBorder: {
    borderBottom: 'none',
    marginBottom: 0,
  },
  noDisplay: {
    display: 'none',
  },
  viewmoreWrapper: {
    '& a': {
      cursor: 'pointer',
      color: '#130F26 !important',
      fontWeight: '500',
      fontSize: '14px',
      '&:hover': {
        textDecoration: 'none',
      },
    },
    textAlign: 'center',
    lineHeight: '150%',
  },
});
export default styles;
